/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import MermaidFigure from '@/components/charts/MermaidFigure';

interface StaticMermaidDiagramProps {
    definition: string;
    fillParent?: boolean;
    theme?: 'light' | 'dark';
}

function StaticMermaidDiagram(props: StaticMermaidDiagramProps) {
    return <MermaidFigure {...props} />;
}

export default StaticMermaidDiagram;
